import { render, staticRenderFns } from "./ProductAdd.vue?vue&type=template&id=0bb10c32&scoped=true&"
import script from "./ProductAdd.vue?vue&type=script&lang=js&"
export * from "./ProductAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb10c32",
  null
  
)

export default component.exports